import axios from 'axios';

import {
	CUSTOMER_CREATED,
	CREATING_CUSTOMER,
	FETCHING_CUSTOMER_DETAILS,
	CUSTOMER_DETAILS_FETCHED,
	UPDATING_CUSTOMER,
	CUSTOMER_UPDATED,
	DELETING_CUSTOMER,
	CUSTOMER_DELETED,
	SMTP_UPDATED,
	UPDATING_SMTP,
} from '../../../actions';
import { API_URL } from '../../../utils/constant';
import { downloadFile } from 'src/utils/utils';
import { toastr } from 'src/utils/toast';

export const createCustomer = async (data, dispatch) => {
	try {
		dispatch({
			type: CREATING_CUSTOMER,
			payload: null,
		});
		const response = await axios.post(`${API_URL}/customers`, data);
		dispatch({
			type: CUSTOMER_CREATED,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: CUSTOMER_CREATED,
				payload: err.response.data,
			});
		}

		dispatch({
			type: CUSTOMER_CREATED,
			payload: { error: true, message: 'Something went wrong' },
		});
	}
};

export const updateCustomer = async (data, dispatch) => {
	try {
		dispatch({
			type: UPDATING_CUSTOMER,
			payload: null,
		});
		const response = await axios.put(`${API_URL}/customers`, data);
		dispatch({
			type: CUSTOMER_UPDATED,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: CUSTOMER_UPDATED,
				payload: err.response.data,
			});
		}

		dispatch({
			type: CUSTOMER_UPDATED,
			payload: { error: true, message: 'Something went wrong' },
		});
	}
};

export const deleteCustomer = async (customerId, dispatch) => {
	try {
		dispatch({
			type: DELETING_CUSTOMER,
			payload: null,
		});
		const response = await axios.delete(`${API_URL}/customers`, { params: { customerId } });
		dispatch({
			type: CUSTOMER_DELETED,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: CUSTOMER_DELETED,
				payload: err.response.data,
			});
		}

		dispatch({
			type: CUSTOMER_DELETED,
			payload: { error: true, message: 'Something went wrong' },
		});
	}
};

export const harddeleteCustomer = async (customerId, confirmName, dispatch) => {
	try {
		dispatch({
			type: DELETING_CUSTOMER,
			payload: null,
		});
		const response = await axios.delete(`${API_URL}/deletecustomers`, { params: { customerId, confirmName } });
		dispatch({
			type: CUSTOMER_DELETED,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: CUSTOMER_DELETED,
				payload: err.response.data,
			});
		}

		dispatch({
			type: CUSTOMER_DELETED,
			payload: { error: true, message: 'Something went wrong' },
		});
	}
};

export const restoreCustomer = async (customerId, dispatch) => {
	try {
		dispatch({
			type: DELETING_CUSTOMER,
			payload: null,
		});
		const response = await axios.put(`${API_URL}/customers/${customerId}/restore`);
		dispatch({
			type: CUSTOMER_DELETED,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: CUSTOMER_DELETED,
				payload: err.response.data,
			});
		}

		dispatch({
			type: CUSTOMER_DELETED,
			payload: { error: true, message: 'Something went wrong' },
		});
	}
};

export const fetchCustomerDetails = async (customerId, dispatch) => {
	try {
		dispatch({
			type: FETCHING_CUSTOMER_DETAILS,
			payload: null,
		});
		const response = await axios.get(`${API_URL}/customers/${customerId}/details`);
		dispatch({
			type: CUSTOMER_DETAILS_FETCHED,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: CUSTOMER_DETAILS_FETCHED,
				payload: err.response.data,
			});
		}

		dispatch({
			type: CUSTOMER_DETAILS_FETCHED,
			payload: { error: true, message: 'Something went wrong' },
		});
	}
};

export const updateSMTPDetails = async (data, dispatch) => {
    try {
        dispatch({
            type: UPDATING_SMTP,
            payload: null,
        });
        const response = await axios.put(`${API_URL}/smtp/configure`, data);
        dispatch({
            type: SMTP_UPDATED,
            payload: response.data,
        });
        toastr.success('Success', 'SMTP details configured successfully.');
        return response.data;
    } catch (err) {
        if (err.response) {
            dispatch({
                type: SMTP_UPDATED,
                payload: err.response.data,
            });
            toastr.error('Error', err.response.data.message || 'Failed to configure SMTP details.');
            return { error: true, message: err.response.data.message || 'Failed to configure SMTP details.' };
        } else {
            dispatch({
                type: SMTP_UPDATED,
                payload: { error: true, message: 'Something went wrong' },
            });
            toastr.error('Error', 'Something went wrong');
            return { error: true, message: 'Something went wrong' };
        }
    }
};

export const exportActiveCustomers = async (query) => {
	return await downloadFile(`${API_URL}/customers`, { ...query, export: true });
};

export const testSMTP = async (data) => {
    try {
        const response = await axios.post(`${API_URL}/smtp/test`, data);
        return response.data;
    } catch (err) {
        throw err.response?.data || { message: 'Failed to send test email.' };
    }
};

export const toggleMFA = async (customerId, mfaEnabled) => {
    try {
        const response = await axios.put(`${API_URL}/customers/${customerId}/mfa`, { customerId, mfaEnabled });
        return response.data;
    } catch (err) {
        throw err.response?.data || { message: 'Failed to update MFA setting.' };
    }
};

export const updateSSOConfig = async (data) => {
    try {
        const response = await axios.put(`${API_URL}/customers/sso-config`, data);
        return response.data;
    } catch (err) {
        throw err.response?.data || { message: 'Failed to update SSO configuration.' };
    }
};